export const KYC = {
  page: 'kyc-page',
  menuButton: 'kyc-menu-button',
  menuOverlay: 'kyc-menu-overlay',
  menuClose: 'kyc-menu-close',
  bell: 'kyc-bell',
  langToggle: 'kyc-lang-toggle',
  brandHome: 'kyc-brand-home',
  copyButton: (k) => `kyc-copy-${k}`,
  nameInput: 'kyc-name-input',
  refInput: 'kyc-ref-input',
  addressInput: 'kyc-address-input',
  pasteButton: 'kyc-paste-button',
  submitButton: 'kyc-submit-button',
  renewButton: 'kyc-renew-button',
  renewPasteButton: 'kyc-renew-paste-button',
  statusPanel: 'kyc-status-panel',
  statusBadge: 'kyc-status-badge',
  statusRefresh: 'kyc-status-refresh',
};
